// /src/pages/private/members/personalhub/dashboard/dashboardGameloopTagsApi.js

import axios from "axios";
import { sanitizeRequestCommentDraft, sanitizeTagIds } from "../../../../../utils/sanitizeUserTextInput";

/** @param {number} handleId */
export async function fetchDashboardGameloopTags(handleId) {
  const { data } = await axios.post(
    "/api/user/private-dashboard/gameloop-tags",
    { handleId },
    { withCredentials: true }
  );
  return data;
}

/** @param {number} handleId @param {number[]} tagIds */
export async function saveDashboardGameloopTags(handleId, tagIds) {
  const { data } = await axios.post(
    "/api/user/private-dashboard/gameloop-tags-save",
    { handleId, tagIds: sanitizeTagIds(tagIds) },
    { withCredentials: true }
  );
  return data;
}

/**
 * @param {number} handleId
 * @param {{
 *   divisionId: number|null,
 *   branchId: number|null,
 *   sectionId: number|null,
 *   membershipAssignmentId?: number|null,
 *   requestComment?: string|null,
 * }} choice
 */
export async function saveDashboardOrgStructure(handleId, choice) {
  const { data } = await axios.post(
    "/api/user/private-dashboard/org-structure-save",
    {
      handleId,
      divisionId: choice.divisionId,
      branchId: choice.branchId,
      sectionId: choice.sectionId,
      membershipAssignmentId: choice.membershipAssignmentId ?? null,
      requestComment: sanitizeRequestCommentDraft(choice.requestComment ?? '').trim() || null,
    },
    { withCredentials: true }
  );
  return data;
}

/** @param {number} handleId @param {number} changeRequestId */
export async function ackDashboardOrgStructureResolveMessage(handleId, changeRequestId) {
  const { data } = await axios.post(
    "/api/user/private-dashboard/org-structure-resolve-ack",
    { handleId, changeRequestId },
    { withCredentials: true }
  );
  return data;
}
